import React from 'react';

import { Scrim, Spinner, Copy, Title, Subtitle } from './LogoProcessingOverlay.styles';

/**
 * Whole-screen loading state shown while an owner-uploaded logo is being uploaded
 * and its background removed (a synchronous ~2s job). Covers the entire wizard so
 * the step can't be interacted with until the processed logo is ready.
 */
export const LogoProcessingOverlay = (): React.ReactElement => (
  <Scrim role="alert" aria-busy="true">
    <Spinner aria-hidden="true" />
    <Copy>
      <Title text="Preparing your logo" tag="h2" />
      <Subtitle text="Removing the background so it looks sharp on every surface." tag="paragraph" />
    </Copy>
  </Scrim>
);

export default LogoProcessingOverlay;
